export default "<p>Signing out...</p>\n"